//src/components/LazyMount.js
import React, { useEffect, useRef, useState } from "react";

function LazyMount({
  children,
  rootMargin = "700px",
  placeholderClassName = "",
}) {
  const ref = useRef(null);
  const [shouldMount, setShouldMount] = useState(false);

  useEffect(() => {
    if (shouldMount) return;

    const node = ref.current;
    if (!node) return;

    if (!("IntersectionObserver" in window)) {
      setShouldMount(true);
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setShouldMount(true);
          observer.disconnect();
        }
      },
      {
        root: null,
        rootMargin,
        threshold: 0,
      }
    );

    observer.observe(node);

    return () => observer.disconnect();
  }, [shouldMount, rootMargin]);

  return (
    <div ref={ref} className={placeholderClassName}>
      {shouldMount ? children : null}
    </div>
  );
}

export default LazyMount;
